import { useTranslation } from 'react-i18next';
import SelectField, { SelectOption } from 'src/components/admin/form/selectField';
import { useAdminSites } from 'src/hooks/useAdminSites';

type SiteFilterSelectProps = {
   value?: string;
   onChange: (siteId: string | undefined) => void;
   className?: string;
   title?: string;
   inputClassName?: string;
};

/** Optional Site filter for admin lists. Empty means every site (NPT-2096). */
const SiteFilterSelect = ({
   value,
   onChange,
   className = 'w-full md:w-auto md:min-w-[170px]',
   title,
   inputClassName = 'min-h-8',
}: SiteFilterSelectProps) => {
   const [t] = useTranslation();
   const { sites } = useAdminSites();
   const options: SelectOption[] = sites.map(site => ({ value: site.id, label: site.displayName ?? site.code ?? site.id }));

   return (
      <div className={className}>
         <SelectField
            clearable
            options={options}
            placeholder={t('admin.sites.allSites')}
            searchable={false}
            theme={{ container: 'w-full', border: 'border-border', input: inputClassName }}
            title={title}
            onChange={(option: SelectOption | SelectOption[]) => onChange((option as SelectOption | undefined)?.value || undefined)}
            value={value}
         />
      </div>
   );
};

export default SiteFilterSelect;
